export default "__VITE_ASSET__C4ug$sCV__"